/* * @Author: chenhui@didichuxing.com * @Date: 2018-12-17 * @Description: x推c落地页首页 */
<template>
  <div class="xtc-rules-container">
    <div class="page-content">
      <div v-if="country === 'CO'" class="rules-terms" @click="openTerms">
        {{ _('FoodC_Promotions_hkSD_CMsv') }}
      </div>
      <ul v-if="country !== 'CO'">
        <li v-for="(item, index) in ruleList" :key="index">{{ index + 1 }}. {{ item }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import currentTrans from '@/common/js/currency-config'
import trackEvent from '@/common/js/track'
import { setTitle } from '@/common/js/bridge'
import { getLocaleBrandText, getTelNum, getEmail } from '@/common/js/utils'
import { sprintf, getLanguageLong } from '@didi/gettext'
import rule from './ruleConf.js'
export default {
  name: 'DetailRules',
  props: {
    country: {
      type: String,
      default: 'MX',
    },
  },
  data() {
    return {
      ruleList: [],
    }
  },
  computed: {
    ...mapGetters(['globalParams', 'acquisitionInfo']),
    // country () {
    //   return this.$store.state.country
    // },
    currentLang() {
      return getLanguageLong()
    },
    rewardInfo() {
      return (
        (this.acquisitionInfo.recommendPage && this.acquisitionInfo.recommendPage.rewardInfo) || {}
      )
    },
    ladderAmountSplit() {
      return (
        this.acquisitionInfo.recommendPage && this.acquisitionInfo.recommendPage.ladderAmountSplit
      )
    },
    rewardAmount() {
      // 有ladderAmountSplit代表阶梯奖，没有代表普通奖
      return this.ladderAmountSplit
        ? this.ladderAmountSplit.display || ''
        : this.rewardInfo.amountSplit
        ? this.rewardInfo.amountSplit.display
        : ''
    },
  },
  created() {
    setTitle(this.gettext('推荐有奖'))
    this.setRuleList()
    trackEvent({
      eventId: 'sailing_c_x_invitation_rule_detail_sw',
      eventLabel: '推荐有奖详细规则',
      attrs: {
        from_page: 'CC',
        activity_id: this.acquisitionInfo.activityID,
      },
    })
  },
  methods: {
    openTerms() {
      if (window.SodaBridge) {
        window.SodaBridge('openPage', {
          target: 'blank',
          url: 'https://h5.didiglobal.com/silver-bullet-online/foodCGCTerms',
        })
      } else {
        window.location.href = 'https://h5.didiglobal.com/silver-bullet-online/foodCGCTerms'
      }
    },
    getCurrency(current) {
      return (currentTrans[current] || currentTrans['']).symbol
    },
    getMoney(current, money, item) {
      if (!money) return 0
      const res = currentTrans[current] || currentTrans['']
      return parseInt(money / res.rate)
    },
    setRuleList() {
      switch (this.country) {
        case 'JP':
          this.ruleList = [
            this.$t(rule[13]),
            this.$t(rule[14], { productname_didi_food: getLocaleBrandText('brand_txt_2') }),
            this.$t(rule[15], { productname_didi_food: getLocaleBrandText('brand_txt_2') }),
            this.$t(rule[16], { productname_didi_food: getLocaleBrandText('brand_txt_2') }),
            this.$t(rule[17]),
            this.$t(rule[18], {
              activity_city: '',
              productname_didi_food: getLocaleBrandText('brand_txt_2'),
            }),
            this.$t(rule[19]),
            this.$t(rule[20], { contact_email: getEmail(this.country) }),
          ]
          break
        case 'CR':
          this.ruleList = [
            `${rule[1]}：${this.acquisitionInfo.recommendPage.startTimeDisplay}-${this.acquisitionInfo.recommendPage.endTimeDisplay}`,
            sprintf(rule[2], getLocaleBrandText('brand_txt_2'), this.rewardAmount),
            sprintf(rule[3], getLocaleBrandText('brand_txt_4')),
            sprintf(rule[4], getLocaleBrandText('brand_txt_2')),
            sprintf(rule[5], getLocaleBrandText('brand_txt_4')),
            rule[6],
            sprintf(
              rule[7],
              this.acquisitionInfo.cityNames || this.acquisitionInfo.cityName,
              getLocaleBrandText('brand_txt_2'),
            ),
            sprintf(rule[8], getLocaleBrandText('brand_txt_2')),
            rule[9],
            rule[10],
            rule[11],
            `${sprintf(rule[12], getLocaleBrandText('brand_txt_2'))}: ${getTelNum(this.country)}`,
            this.$t(rule[13]),
            this.$t(rule[21]),
          ]
          break
        case 'MX':
          this.ruleList = [
            this.gettext('FoodC_CGC_QXwb_BKmD')
              .replace('{{startdate}}', this.acquisitionInfo.recommendPage.startTimeDisplay)
              .replace('{{enddate}}', this.acquisitionInfo.recommendPage.endTimeDisplay),
            this.gettext('FoodC_CGC_KVtY_VNSE')
              .replace(/{{app_name}}/g, getLocaleBrandText('brand_txt_2'))
              .replace('{{amount}}', this.rewardAmount),
            this.gettext('FoodC_CGC_UFif_hfJM')
              .replace(/{{app_name}}/g, getLocaleBrandText('brand_txt_4'))
              .replace('{{num}}', 48),
            this.gettext('FoodC_CGC_XBGw_UVvR')
              .replace(/{{app_name}}/g, getLocaleBrandText('brand_txt_2'))
              .replace('{{num}}', 1),
            this.gettext('FoodC_CGC_kRMT_EBEL').replace(
              /{{app_name}}/g,
              getLocaleBrandText('brand_txt_4'),
            ),
            this.gettext('FoodC_CGC_JFyK_TjqE'),
            this.gettext('FoodC_CGC_qcLp_cjum')
              .replace(/{{app_name}}/g, getLocaleBrandText('brand_txt_2'))
              .replace(
                '{{city_list}}',
                this.acquisitionInfo.localCityNames ||
                  this.acquisitionInfo.cityNames ||
                  this.acquisitionInfo.cityName,
              ),
            this.gettext('FoodC_CGC_SaMA_ymHl').replace(
              /{{app_name}}/g,
              getLocaleBrandText('brand_txt_2'),
            ),
            this.gettext('FoodC_CGC_PFoL_QAIo'),
            this.gettext('FoodC_CGC_gLdR_yRZb'),
            this.gettext('FoodC_CGC_WOQY_zerr'),
            `${this.gettext('FoodC_CGC_xGpr_jdrf').replace(
              /{{app_name}}/g,
              getLocaleBrandText('brand_txt_2'),
            )}: ${getTelNum(this.country)}`,
            this.gettext('FoodC_CGC_wkuZ_BrqU'),
          ]
          break
        case 'BR':
          this.ruleList = [
            this.gettext('FoodC_CGC_QXwb_BKmD')
              .replace('{{startdate}}', this.acquisitionInfo.recommendPage.startTimeDisplay)
              .replace('{{enddate}}', this.acquisitionInfo.recommendPage.endTimeDisplay),
            this.gettext('FoodC_CGC_KVtY_VNSE')
              .replace(/{{app_name}}/g, this.gettext('FoodC_name_99_Takeaway_GFhX'))
              .replace('{{amount}}', this.rewardAmount),
            this.gettext('FoodC_campaign_aFBJ_ipZl')
              .replace(/{{99Food}}/g, this.gettext('FoodC_name_99_Takeaway_GFhX'))
              .replace('{{num}}', 48),
            this.gettext('FoodC_CGC_XBGw_UVvR')
              .replace(/{{app_name}}/g, this.gettext('FoodC_name_99_Takeaway_GFhX'))
              .replace('{{num}}', 1),
            this.gettext('FoodC_CGC_kRMT_EBEL').replace(
              /{{app_name}}/g,
              this.gettext('FoodC_name_99_Takeaway_GFhX'),
            ),
            this.gettext('FoodC_CGC_JFyK_TjqE'),
            this.gettext('FoodC_CGC_qcLp_cjum')
              .replace(/{{app_name}}/g, this.gettext('FoodC_name_99_Takeaway_GFhX'))
              .replace(
                '{{city_list}}',
                this.acquisitionInfo.localCityNames ||
                  this.acquisitionInfo.cityNames ||
                  this.acquisitionInfo.cityName,
              ),
            this.gettext('FoodC_campaign_RqSl_PwEk').replace(
              /{{99Food}}/g,
              this.gettext('FoodC_name_99_Takeaway_GFhX'),
            ),
            this.gettext('FoodC_CGC_PFoL_QAIo'),
            this.gettext('FoodC_CGC_gLdR_yRZb'),
            this.gettext('FoodC_CGC_WOQY_zerr'),
            `${this.gettext('FoodC_CGC_xGpr_jdrf').replace(
              /{{app_name}}/g,
              this.gettext('FoodC_name_99_Takeaway_GFhX'),
            )}: ${getTelNum(this.country)}`,
            this.gettext('FoodC_CGC_wkuZ_BrqU'),
          ]
          break
        default:
          this.ruleList = [
            `${rule[1]}：${this.acquisitionInfo.recommendPage.startTimeDisplay}-${this.acquisitionInfo.recommendPage.endTimeDisplay}`,
            sprintf(rule[2], getLocaleBrandText('brand_txt_2'), this.rewardAmount),
            sprintf(rule[3], getLocaleBrandText('brand_txt_4')),
            sprintf(rule[4], getLocaleBrandText('brand_txt_2')),
            sprintf(rule[5], getLocaleBrandText('brand_txt_4')),
            rule[6],
            sprintf(
              rule[7],
              this.acquisitionInfo.cityNames || this.acquisitionInfo.cityName,
              getLocaleBrandText('brand_txt_2'),
            ),
            sprintf(rule[8], getLocaleBrandText('brand_txt_2')),
            rule[9],
            rule[10],
            rule[11],
            `${sprintf(rule[12], getLocaleBrandText('brand_txt_2'))}: ${getTelNum(this.country)}`,
            this.$t(rule[13]),
          ]
          break
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
.xtc-rules-container {
  .page-content {
    font-family: 'Aspira Regular';
    font-size: 24px;
    color: #666666;
    text-align: left;
    line-height: 28px
    margin: 40px 40px 127px;
    text-align: left;
    font-size: 26px
    ul {
      line-height 42px
    }
    .rules-terms{
      text-decoration:underline;
      font-weight:600;
      margin-bottom:20px;
      margin-left:-20px;
      font-size: 28px;
      color: #000000;
    }
  }
}
</style>
